module.exports = __webpack_public_path__ + "static/media/Aeonik-Regular.844324dc.otf";